// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.transparent-card[data-v-45d8aa27] {\n    border: none;\n    background-color: rgba(1, 1, 1, 0);\n}\n", ""]);
// Exports
module.exports = exports;
